import PubNub from 'pubnub';
import forEach from 'lodash.foreach';
import { UPDATE_PUBNUB_ONLINE_STATUS } from './network/network.type';

/* eslint-disable */
const messaging = {
  state: {
    channels: {},
    pubnubInstance: null,
    handleMessages: true,
  },
  actions: {
    initMessaging({ commit, dispatch, state }) {
      var user = this.state.authorization.user;
      if (!user) {
        console.warn('NO USER DETECTED. ARE YOU SURE YOU\'RE LOGGED IN?');
        return false;
      }
      var pubnubInstance = new PubNub({
        subscribeKey: import.meta.env.VITE_PUBNUB_SUBSCRIBE_KEY,                
        uuid: `${user.user_id}`,
        ssl: true,
      });
      commit('setpubnubInstance', pubnubInstance);
      dispatch('subscribeCurrentUser');
    },
    disableMessaging( {
      commit,
      state,
    }) {
      if (state.pubnubInstance) {
        state.pubnubInstance.unsubscribeAll();
        state.pubnubInstance.stop();
        state.pubnubInstance.destroy();
        commit('removeChannels', Object.keys(state.channels));
      }
      commit('setpubnubInstance', null);
    },
    subscribeToChannel( { commit, dispatch }, channelKey) {
      if (!channelKey) return;
      if (!this.getters.currentUser) return;
      try {
        this.state.messaging.pubnubInstance.subscribe({
          channels: [channelKey],
        });
      } catch (err) {
        // do nothing
      }

      commit('addChannel', channelKey);
    },
    subscribeToChannels( { commit, dispatch }, channelKeys) {
      if (channelKeys.length === 0) return;
      if (!this.getters.currentUser) return;
      try {
        this.state.messaging.pubnubInstance.subscribe({
          channels: channelKeys,
        });
      } catch (err) {
        // do nothing
      }

      commit('addChannels', channelKeys);
    },
    subscribeCurrentUser( { dispatch }) {
      const user = this.state.authorization.user;
      const channelKey = `user.${ user.user_id }`;
      this.state.messaging.pubnubInstance.addListener({
        message: (message) => {
          dispatch('handleMessage', { channelKey, message });
        },
        status: (status) => {
          dispatch('handleStatus', { channelKey, status });
        }
      });
      dispatch('subscribeToChannel', channelKey);
    },
    unsubscribeCurrentUser( { commit, state }) {
      if (state.pubnubInstance) {
        const user = this.state.authorization.user;
        const channelKey = `user.${ user.user_id }`;
        state.pubnubInstance.unsubscribe({
          channels: [channelKey],
        });
        commit('removeChannels', [channelKey]);
      }
    },
    unsubscribeToChannels( { commit, state }, channelKeys) {
      if (state.pubnubInstance) {
        state.pubnubInstance.unsubscribe({
          channels: channelKeys,
        });
        commit('removeChannels', channelKeys);
      }
    },
    unsubscribeToChannel( { dispatch }, channelKey) {
      dispatch('unsubscribeToChannels', [channelKey]);
    },
    handleMessage( { commit, rootState }, { channelKey, message }) {
      //TODO - do something with them - etc;

      if (import.meta.env.DEV && rootState.devTools.pubnubLoggingEnabled) {
        console.log('MESSAGE RECEIVED:');
        console.log(message);
        commit('addToChannelHistory', { channelKey, messageType: 'message', message });
      }
    },
    handleStatus( { commit, dispatch, rootState }, { channelKey, status }) {
      switch (status.category) {
        case 'PNNetworkDownCategory':
          dispatch(UPDATE_PUBNUB_ONLINE_STATUS, false);
          break;
        case 'PNNetworkUpCategory':
          dispatch(UPDATE_PUBNUB_ONLINE_STATUS, true);
          break;
        default:
          break
      }

      if (import.meta.env.DEV && rootState.devTools.pubnubLoggingEnabled) {
        console.log('STATUS RECEIVED:');
        console.log(status);
        commit('addToChannelHistory',{ channelKey, messageType: 'status', message: status });
      }
    },
    updateHandleMessages({ commit }, handleMessages) {
      commit('setHandleMessages', handleMessages);
    },
  },
  mutations: {
    setpubnubInstance(state, pubnubInstance) {
      state.pubnubInstance = pubnubInstance;
    },
    addChannel(state, channelKey) {
      state.channels[channelKey] = { status: [], message: []};
    },
    addChannels(state, channelKeys) {
      forEach(channelKeys, (channelKey) => {
        state.channels[channelKey] = { status: [], message: []};
      });
    },
    removeChannel(state, channelKey) {
      delete state.channels[channelKey];
    },
    removeChannels(state, channelKeys) {
      forEach(channelKeys, (channelKey) => {
        delete state.channels[channelKey];
      });
    },
    addToChannelHistory(state, { channelKey, messageType, message }) {
      if (state.channels[channelKey]) {
        state.channels[channelKey][messageType].push(message);
      }
    },
    setHandleMessages(state, handleMessages) {
      state.handleMessages = handleMessages;
    },
  },
};

export default messaging;
